module.exports = __webpack_public_path__ + "img/title.f8543b0e.png";